import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { brandColors } from '../../theme';

const MarketPulsePage: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: brandColors.white }}>
      {/* Hero/Header */}
      <Box sx={{ background: `linear-gradient(to bottom, ${brandColors.white}, ${brandColors.lightGray})`, pb: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg" sx={{ pt: 8 }}>
          <Typography
            component="h1"
            sx={{
              color: brandColors.blue,
              fontWeight: 400,
              fontSize: { xs: '2.25rem', sm: '2.75rem', md: '3.25rem' },
              lineHeight: 1.05,
              letterSpacing: '-0.5px',
              mb: 2,
            }}
          >
            Market Pulse
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: brandColors.mediumGray, fontWeight: 400, maxWidth: 900 }}
          >
            Timely perspectives from Horwath HTL hospitality experts on what’s moving lodging markets—
            from demand shifts and pricing trends to investment, pipeline, and policy.
          </Typography>
        </Container>
      </Box>

      {/* About Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Typography variant="h5" sx={{ color: brandColors.indigo, fontWeight: 700, mb: 2 }}>
              What is Market Pulse?
            </Typography>
            <Typography variant="body1" sx={{ color: brandColors.mediumGray, lineHeight: 1.9, mb: 3 }}>
              Market Pulse is your living stream of expert commentary about the global hospitality market. 
              It complements our in-depth MarketCompass Lodging Reports with faster observations and practical insights that help you stay ahead.
            </Typography>

            <Typography variant="h6" sx={{ color: brandColors.indigo, fontWeight: 700, mb: 1.5 }}>
              What to expect
            </Typography>
            <ul style={{ marginTop: 0, color: brandColors.mediumGray }}>
              <li>Short takes on timely developments (150–400 words)</li>
              <li>Briefings with charts and context (3–6 minute reads)</li>
              <li>Data snapshots on ADR, RevPAR, supply, and demand</li>
              <li>Occasional interviews and event recaps</li>
            </ul>

            <Typography variant="h6" sx={{ color: brandColors.indigo, fontWeight: 700, mt: 4, mb: 1.5 }}>
              How this section will evolve
            </Typography>
            <Typography variant="body1" sx={{ color: brandColors.mediumGray, lineHeight: 1.9 }}>
              We’ll be introducing topic filters, geography filters (continent, country, market), and series labels to make it easy to explore what matters to you. 
              You’ll also see related MarketCompass reports suggested next to each post.
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, border: `1px solid ${brandColors.lightGray}` }}>
              <Typography variant="subtitle1" sx={{ color: brandColors.indigo, fontWeight: 700, mb: 1 }}>
                Coming soon
              </Typography>
              <ul style={{ marginTop: 0, color: brandColors.mediumGray }}>
                <li>Topic filters (Demand, Pricing, Pipeline, Investment)</li>
                <li>Geography filters (Continent, Country, Market)</li>
                <li>Series labels (Pulse, Briefing, Deep Dive)</li>
                <li>Email subscribe and RSS</li>
              </ul>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MarketPulsePage;


